import React, { useState } from "react";
import GroupsIcon from "@mui/icons-material/Groups";

import {
  CreateTableNew as CreateTable,
  SearchBar,
} from "../../../common/APICommon";

import { fetchCrewByVessel } from "../EmployeesListFld/EmployeesListApi";
import { LoadingSpinner } from "../../../common/Loading";
import { useCrewList } from "./shared/useCrewList";
import { CrewDetailModal } from "./shared/CrewDetailModal";

const CrewList = ({ user, isHideSideMenu }) => {
  const { loading, data, handleFilter } = useCrewList();

  const [showModal, setShowModal] = useState(false);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [crewDetail, setCrewDetail] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const openModal = async (row) => {
    setSelectedVessel(row);
    setShowModal(true);
    setDetailLoading(true);
    const detail = await fetchCrewByVessel(row.vesselId);
    setCrewDetail(detail);
    setDetailLoading(false);
  };

  const headers = ["ID", "Vessel Name", "Destination Head", "Onboard Crew", "Actions"];
  const accessors = ["vesselId", "vesselName", "destinationHeadName", "crewCount", "actions"];

  const actions = [
    {
      name: "View Crew",
      icon: <GroupsIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600 flex items-center",
      function: (row) => openModal(row),
      visible: true,
    },
  ];

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Personnel >"}</span>
                <span style={{ borderBottom: "1px solid black" }}>{"Crew List"}</span>
              </div>
              <h3>Crew List</h3>
            </div>

            <div className='p-4 space-y-4'>
              <SearchBar handleFilter={handleFilter} />
              <CreateTable
                tableName="CrewListTable"
                headers={headers}
                accessors={accessors}
                data={data}
                actions={actions}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={10}
                totalItems={data?.length}
              />
            </div>
            
            <CrewDetailModal
              isOpen={showModal}
              onClose={() => setShowModal(false)}
              vessel={selectedVessel}
              crew={crewDetail}
              loading={detailLoading}
            />

            <LoadingSpinner loading={loading} />
          </div>
        </div>

      </div>

    </>

  );
};

export default CrewList;